export const suggestedInventoryExpenseSheetProps = {
    key: 0,
    recipe_id: 0,
    inventory_item_id: 0, 
    cost_per_unit: 0, 
    presentation: 0,
    required_quantity: 1, 
    subtotal: 0, 
    average_guests: 1, 
    
    recipe_cost: 0,
    required_portion_qty: 0,    

    inventory_unit_cost: 0
}

export const recipeProps = {
    key: 0,
    description: ''
}

export const basicProps = {
    key: 0,
    id: 0,
    recipe_name: '',
    quantity_per_guest: 0,
    sub_menu_id: 0,
    portion_qty: 1,
    recipe_photo: '',
    recipe_list: [JSON.parse(JSON.stringify(recipeProps))],
    suggested_inventory_expense_sheet: [JSON.parse(JSON.stringify(suggestedInventoryExpenseSheetProps))],
    unit_cost: 0
}




// WEBPACK FOOTER //
// ./src/store/modules/recipe/properties.js